import BaseService from "@/services/BaseService";

export default class EquivalenceConfigurationService extends BaseService {
  constructor(serviceName) {
    super('insurance_pricing/equivalence_configuration');
  }

  get(id) {
    return this.http.get(`${this._serviceName}/${id}`);
  }

  findAllByParams(data) {
    return this.http.get(`${this._serviceName}/findAllByParams`, { params: data });
  }

  findProviders(id) {
    return this.http.get(`${this._serviceName}/${id}/providers`);
  }

  findCarriers(id) {
    return this.http.get(`${this._serviceName}/${id}/carriers`);
  }

  findPlans(id, carrierId) {
    return this.http.get(`${this._serviceName}/${id}/${carrierId}/plans`);
  }

  findPlansByCarrier(id, carrierId, regionId) {
    return this.http.get(`${this._serviceName}/${id}/carriers/${carrierId}/plans`, { params: { regionId } });
  }

  save(data) {
    return this.http.post(`${this._serviceName}/` , data);
  }
  
  update(data) {
    return this.http.put(`${this._serviceName}/${data.id}` , data);
  }

  delete(id) {
    return this.http.delete(`${this._serviceName}/${id}`);
  }

  /* ------------- ORDER CONFIGURATION ------------- */
  findOrderConfigurationByParams(equivConfId, data) {
    return this.http.get(`${this._serviceName}/${equivConfId}/order_configuration/view`, { params: data });
  }

  createOrderConfiguration(equivConfId, data) {
    return this.http.post(`${this._serviceName}/${equivConfId}/order_configuration`, data);
  }

  updateProviderOrderConfiguration(equivConfId, ordConfId, pocList) {
    return this.http.put(`${this._serviceName}/${equivConfId}/order_configuration/${ordConfId}/`, pocList);
  }

  createPlanOrderEquivalenceConfiguration(equivConfId, data) {
    return this.http.post(`${this._serviceName}/${equivConfId}/plan_order_equivalence_configurations`, data);
  }

  updateHideProviderExibitionConfiguration(equivConfId, pecId, value) {
    return this.http.put(`${this._serviceName}/${equivConfId}/provider_exibition_configuration/${pecId}/`, value);
  }

  updateHideProviderOrderConfiguration(equivConfId, pocId, value) {
    return this.http.put(`${this._serviceName}/${equivConfId}/provider_order_configuration/${pocId}/`, value);
  }

  findAllReferenceCarriersByRegionAndBenefit(regionId,benefitId,studyConfigurationId,currentPlanIds, specific) {
    let data = {
      benefitId: benefitId,
      regions: regionId,
      studyConfigurationId: studyConfigurationId,
      currentPlanIds: currentPlanIds,
      specific: specific
    };
    return this.http.post(`${this._serviceName}/carriers/references`,data);
  }

  async findAllReferencePlansByRegionAndBenefit(regionId,benefitId,carrierId,studyConfigurationId,currentPlanIds, specific) {
    let data = {
      benefitId: benefitId,
      regions: regionId,
      carrierId: carrierId,
      studyConfigurationId: studyConfigurationId,
      currentPlanIds: currentPlanIds,
      specific: specific
    };
    return await this.http.post(`${this._serviceName}/plans/references`,data);
  }

  findAllEquivalentCarriersByRegionAndBenefit(regionId,referencePlanIds, benefitId,studyConfigurationId,currentPlanIds, specific) {
    let data = {
      benefitId: benefitId,
      regions: regionId,
      studyConfigurationId: studyConfigurationId,
      referencePlanIds: referencePlanIds,
      currentPlanIds: currentPlanIds,
      specific: specific
    };
    return this.http.post(`${this._serviceName}/carriers/equivalents`,data);
  }

  async findAllEquivalentPlansByRegionAndBenefit(regionId,benefitId,carrierId,referencePlanId,
    proposePlanIds,studyConfigurationId,currentPlanIds, specific) {
    
      let data = {
        benefitId: benefitId,
        carrierId: carrierId,
        regions: regionId,
        planId: referencePlanId,
        proposePlanIds: proposePlanIds,
        studyConfigurationId: studyConfigurationId,
        currentPlanIds: currentPlanIds,
        specific: specific
      };

    return await this.http.post(`${this._serviceName}/plans/equivalents`,data);
  }
}  
